module.exports = {"SearchBar":{"RecentSearches":"Recent searches"},"CookieDisclaimer":{"link":"discover/marketing-terms-and-conditions/privacy-policy-cookies/?r=1"}}


//////////////////
// WEBPACK FOOTER
// ../i18n/en-au.json
// module id = ../i18n/en-au.json
// module chunks = client.sitechrome